import React from 'react';
import { useEffectOnce } from 'react-use';

import { CA } from 'contexts';
import { useApi } from 'hooks';
import { queryParam } from 'utils/query';
import { RHP } from 'providers';
// import { useApi } from 'hooks';

export function useRankingCorporate() {
    const { state } = React.useContext(CA);

    const api = useApi();

    // Initial values for the state
    const initial = {
        application: { applied: false, steps: {} },
        redirectTo: queryParam('returnUrl'),
        contracts: [],
        companies: [],
        companyDetails: state.user.company,
        validate: false,
        relationships: [],
        companyId: state.user.company.id,
        ranking: {
            id: '2023evaluator',
            name: '2023evaluator',
            year: '2023',
            country: 'BR',
        },
        currentRanking: {
            id: '2023corps',
            name: '2023corps',
            year: '2023',
            country: 'BR',
        },
        contractPoints: 0,
    };

    // Check for queryStrings
    if (queryParam('contractId') && queryParam('contractResponse')) {
        initial.validate = {
            _id: queryParam('contractId'),
            status: queryParam('contractResponse'),
        };
    }

    // Controls if the module is ready
    const [ready, setReady] = React.useState(false);

    // Define variables holder to be used on the module
    const [vars, setVars] = React.useState(initial);
    const addVars = newVars => {
        setVars(old => ({ ...old, ...newVars }));
    };
    // usuariocompanyid
    // //////////////////////
    //  STARTUP FUNCTIONS  //
    // //////////////////////

    const type2Points = React.useMemo(
        () => ({
            none: 0,
            match: 0,
            mentoring: 1,
            connection: 0,
            award: 1,
            coworking: 1,
            voucher: 1,
            outlicensing: 5,
            resources: 5,
            employee: 5,
            channels: 5,
            acceleration: 5,
            'r&d': 10,
            inlicensing: 10,
            pilot: 10,
            supplying: 10,
            accelerationLarge: 5,
            investmentLarge: 0,
            investment: 0,
            acquisition: 0,
            investment200k: 20,
            acquisition200k: 20,
        }),
        []
    );

    const checkStartupCountry = () => {};

    const calculateContractPoints = React.useCallback(
        async contract => {
            // if (contract.selectedStartup.country && contract.selectedStartup.country !== 'BR') {
            //     addVars({ contractPoints: 0 });
            //     return;
            // }

            const startDate = new Date(contract.startDate);
            let endDate = new Date(contract.endDate);

            if (contract.startDate && !contract.endDate) {
                endDate = new Date(contract.startDate);
                endDate.setFullYear(startDate.getFullYear() + 1);
            }
            // Check the dates
            if (
                endDate >= startDate &&
                endDate >= new Date('2022-07-01') &&
                startDate < new Date('2023-07-01')
            ) {
                if (contract.formalized !== 'true') {
                    addVars({ contractPoints: 0 });
                } else if (
                    contract.valueRange &&
                    Array.isArray(contract.valueRange) &&
                    contract.valueRange[0] >= 200000 &&
                    contract.type !== 'connection'
                ) {
                    addVars({ contractPoints: 20 });
                } else {
                    addVars({ contractPoints: type2Points[contract.type] || 0 });
                }
            } else {
                addVars({ contractPoints: 0 });
            }
        },
        [type2Points]
    );

    // /////////////////////////////////
    // RANKING APPLICATION FUNCTIONS  //
    // /////////////////////////////////

    /**
     * CUSTOM FUNCTIONS
     * ------------------------------------------------------------------------
     */
    // eslint-disable-next-line
    let currentRanking = initial.ranking.id;
    function getRanking(rankingId = currentRanking) {
        return api.get(`/rankings`).then(res => {
            const filtered = res.filter(r => r.id === rankingId);

            addVars({ currentRanking: filtered[0] });
            return filtered[0];
        });
    }

    function getUserRankingApplication() {
        const { userid } = state.user;
        return api.get(`/users/${userid}/rankingapplications/${vars.ranking.name}`).then(res => {
            // console.log('useRankingInvestor', 'getUserRankingApplication', res);
            let application = res;
            if (!res.steps) {
                application = initial.application;
            }
            addVars({ application });
            return res;
        });
    }
    function putUserRankingApplication(payload, updateVars = true) {
        const { userid } = state.user;
        return api
            .put(`/users/${userid}/rankingapplications/${vars.ranking.name}`, payload)
            .then(res => {
                // console.log('useRankingInvestor', 'putUserRankingApplication', res);
                if (updateVars) addVars({ application: res });
                return res;
            });
    }

    /**
     * INCLUDE VARS FUNCTIONS
     * ------------------------------------------------------------------------
     */

    function setReturnTo(href) {
        addVars({ redirectTo: href });
    }

    const updateSteps = update => {
        // Get the current application variable
        const { application } = vars;
        application.steps = { ...application.steps, ...update };
        addVars({ application });
        return putUserRankingApplication({ ...application }, false);
    };

    // /////////////////////////////////////
    // RELATIONSHIP VALIDATION FUNCTIONS  //
    // /////////////////////////////////////

    /**
     * CUSTOM FUNCTIONS
     * ------------------------------------------------------------------------
     */

    function getUserContracts(currentRanking = vars.currentRanking) {
        const { userid } = state.auth;

        const handleContracts = res =>
            res.map(contract => {
                const newContract = { ...contract };
                // Se estiver fora do range do Ranking
                if (currentRanking.end && currentRanking.start) {
                    const rankingEnd = new Date(currentRanking.end);
                    const rankingStart = new Date(currentRanking.start);
                    const contractEnd = new Date(newContract.endDate);
                    const contractStart = new Date(newContract.startDate);
                    const contractRegDate = new Date(newContract.regDate);

                    if (contractStart >= rankingEnd || contractEnd < rankingStart) {
                        newContract.invalid = true;
                        newContract.outOfRange = true;
                    }
                    // Se estiver cadastrado a mais de um ano
                    const yearAgo = new Date(currentRanking.start);
                    yearAgo.setFullYear(rankingStart.getFullYear() - 1);
                    if (contractRegDate < yearAgo) {
                        newContract.invalid = true;
                        newContract.expired = true;
                    }
                } else if (
                    newContract.startup?.startupStatus === 'none' &&
                    newContract.status === 'confirmed'
                ) {
                    newContract.status = 'pending';
                }

                return newContract;
            });

        return api
            .get(`/users/${userid}/contracts`)
            .then(handleContracts)
            .then(res => {
                addVars({ contracts: res });
                return res;
            });
    }

    function getUserContractById(investmentId) {
        const { userid } = state.auth;
        return api.get(`/users/${userid}/contracts/${investmentId}`).then(res => {
            // console.log('getUserRelationshipById', investmentId, res);
            return res;
        });
    }

    function postUserContract(payload) {
        // {
        //   contractInfo: {
        //     contractType: 'mentoring',
        //     description: 'Piloto do 100os com xpto',
        //     startDate: '2018-01-01T00:00:00.000Z',
        //     endDate: '2019-04-01T00:00:00.000Z',
        //     formalized: true,
        //     disclosureAllowed: true,
        //     valueRange: [100000, 500000], // Optional
        //   },
        //   startupContact: { // Optional
        //     name: 'Clark Kent', // Optional
        //     email: 'clark.kent@openstartups.net', // Optional
        //   },
        //   startup: {
        //     _id: '5afc879a0dce2d0eaba9f32a', // Optional. If missing, will create new startup
        //     name: 'Acme Inc', // Only considered if no _id sent (will create new startup)
        //   },
        // };

        const { userid } = state.auth;
        return api.post(`/users/${userid}/contracts`, payload).then(res => {
            return getUserContracts();
        });
    }

    function putUserContract(payload) {
        // {
        //     "date": "2019-07-01",
        //     "type": "Angel",
        //     "round": "Seed 2",
        //     "vaue": {"currency": "USD", "amount": 20000 },
        //     "linkUrl": "https://linkao.com.br",
        //     "rankings": { "2020": false }
        // }
        const { userid } = state.auth;
        const { _id } = payload;
        return api.put(`/users/${userid}/contracts/${_id}`, payload).then(res => {
            return getUserContracts();
        });
    }

    function deleteUserContract(payload) {
        const { userid } = state.auth;
        const { _id } = payload;
        return api.delete(`/users/${userid}/contracts/${_id}`).then(res => {
            return getUserContracts();
        });
    }

    function postUserContractValidation(payload) {
        // {
        //     "status": "confirmed",
        //     "lastUpdated": "2020-03-09T20:32:44.701Z"
        // }
        const { userid } = state.auth;
        const { _id } = payload;
        return api.post(`/users/${userid}/contracts/${_id}/validation`, payload).then(res => {
            // console.log('postUserContractValidation', res);
            return getUserContracts();
        });
    }

    // VER COM LEVY
    // function postUserContractValidationEmail(payload) {
    //     const { userid } = state.auth;
    //     const { _id } = payload;
    //     return api.post(`/users/${userid}/contracts/${_id}/sendvalidationemail`);
    // }

    function postUserContractValidationEmail(payload) {
        const { _id } = payload;
        const { userid } = state.auth;
        return api.post(`/users/${userid}/contracts/${_id}/sendemail`);
    }

    function postUserContractReconsideration(payload) {
        const { userid } = state.auth;
        const { _id } = payload;
        return api.post(`/users/${userid}/contracts/${_id}/reconsideration`, payload).then(() => {
            return getUserContracts();
        });
    }

    function getStartupByDomain(startupDomain) {
        return api.get(`/companydomain/${startupDomain}`).then(res => {
            addVars({ searchedStartup: res });
            return res;
        });
    }

    /// /////////////////////////
    //  CORPORATE ECOSYSTEM RELATIONSHIP FUNCTIONS  //
    // //////////////////////

    function getCorpEcosystemRelationships() {
        const { userid } = state.auth;

        return api
            .get(`/users/${userid}/corpecosystemrelationships/`, {
                params: { entity: 'company' },
            })
            .then(res => {
                addVars({ relationships: res });
                return res;
            });
    }
    // function getOneCorpEcosystemRelationships(res) {
    //     const { userid } = state.auth;
    //     const { _id } = res; // id vindo da response od backend
    //     const params = { queryParam: 'company' };
    //     console.log(res, 'payload da get');
    //     return api.get(`/users/${userid}/corpecosystemrelationships/${_id}`, params).then(res => {
    //         addVars({ relationships: res });
    //         return res;
    //     });
    // }
    //  /users/:userid/corpecosystemrelationships
    function postCorpEcosystemRelationship(payload) {
        const { userid } = state.auth;
        return api
            .post(`/users/${userid}/corpecosystemrelationships/`, payload, {
                params: { entity: 'company' },
            })
            .then(res => {
                return getCorpEcosystemRelationships();
            });
    }

    function postCorpEcosystemRelationshipValidation(payload) {
        const { userid } = state.auth;
        // {
        //     "status": "confirmed",
        //     "lastUpdated": "2020-03-09T20:32:44.701Z"
        // }
        const { _id } = payload;
        return api
            .post(`/users/${userid}/corpecosystemrelationships/${_id}/validation`, payload, {
                params: { entity: 'company' },
            })
            .then(res => {
                return getCorpEcosystemRelationships(res);
            });
    }

    function postCorpEcosystemRelationshipValidationEmail(payload) {
        const { userid } = state.auth;
        const { _id } = payload;

        return api.post(
            `/users/${userid}/corpecosystemrelationships/${_id}/sendvalidationemail`,
            payload,
            {
                params: { entity: 'company' },
            }
        );
    }
    // ESSA FUNÇÃO NÃO SERÁ USADA, DE ACORDO COM AS MUDANÇAS DO DOC. VER O COMPONENT RELATIONSHIP, O QUE SERÁ FEITO NO DISPLAY DOS BOTÕES
    // SERÁ SOLICITADO A ALTERAÇÃO AO AGENTE DE ECOSISTEMA?
    function putCorpEcosystemRelationship(payload) {
        const { userid } = state.auth;
        // {
        //     "date": "2019-07-01",
        //     "type": "Angel",
        //     "round": "Seed 2",
        //     "vaue": {"currency": "USD", "amount": 20000 },
        //     "linkUrl": "https://linkao.com.br",
        //     "rankings": { "2020": false }
        // }
        const { _id } = payload;
        // mudar rota, ver com levy
        return api
            .put(`/users/${userid}/corpecosystemrelationships/${_id}`, payload, {
                params: { entity: 'company' },
            })
            .then(res => {
                return getCorpEcosystemRelationships();
            });
    }

    function deleteCorpEcosystemRelationship(payload) {
        const { userid } = state.auth;
        const { _id } = payload;

        return api
            .delete(`/users/${userid}/corpecosystemrelationships/${_id}`, {
                data: { entity: 'company' },
            })
            .then(res => {
                return getCorpEcosystemRelationships();
            });
    }

    /// /////////////////////////
    //  CORPORATE FUNCTIONS  //
    // //////////////////////

    function getCompanyDetails(addResponseToVars = true) {
        if (!vars.companyId) {
            return;
        }
        return api.get(`/companies/${vars.companyId}`).then(res => {
            if (!res) {
                RHP.push('/companies');
            }
            if (addResponseToVars) {
                addVars({ companyDetails: res });
            }
            return res;
        });
    }

    function putCompanyDetails(payload, addResponseToVars = true) {
        return api.put(`/companies/${vars.companyId}`, payload).then(res => {
            if (addResponseToVars) {
                addVars({ companyDetails: res });
            }
            return getCompanyDetails();
        });
    }
    // function getCorporateRankingApplication() {
    //     return api
    //         .get(`/companies/${vars.companyId}/rankingapplications/${vars.ranking.id}`)
    //         .then(res => {
    //             let application = res;
    //             if (!res.steps) {
    //                 application = initial.application;
    //             }
    //             addVars({ application });
    //             return res;
    //         });
    // }

    // function putCorporateRankingApplication(payload, updateVars = true) {
    //     // const companyId = user.company.id;

    //     return api
    //         .put(
    //             `/companies/${vars.companyId}/rankingapplications/${vars.currentRanking.id}`,
    //             payload
    //         )
    //         .then(res => {
    //             getCompanyDetails(vars.companyId);
    //             if (updateVars) addVars({ application: res });
    //             return res;
    //         });
    // }

    function getCorpRankingPosition() {
        return api
            .get(
                `/companies/${vars.companyId}/rankingapplications/${vars.ranking.year}corps/estimation`
            )
            .then(res => {
                addVars({ companyEstimatedPosition: res });
                return res;
            });
    }

    React.useEffect(() => {
        if (vars.companyId) {
            Promise.all([getCompanyDetails()]).then(res => addVars({ companyDetails: res[0] }));
        }
        // eslint-disable-next-line
    }, [vars.companyId]);

    useEffectOnce(() => {
        // Validate investiment if avaliable
        // Validation moved to useRanking()
        // Initialize the module's service
        getRanking()
            .then(res => {
                return Promise.all([
                    getUserRankingApplication(),
                    getCompanyDetails(),
                    getCorpEcosystemRelationships(),
                    getUserContracts(res),
                ]).then(() => setReady(true));
            })
            .catch(err => {
                console.error('useRankingCorporate', err);
                return Promise.all([getUserRankingApplication(), getUserContracts()]).then(() =>
                    setReady(true)
                );
            });
    });

    return {
        // Ready to load?
        ready,
        // Variables handlers
        addVars,
        setVars,
        vars,
        // Include vars functions
        updateSteps,
        setReturnTo,
        putCompanyDetails,
        // Custom functions
        checkStartupCountry,
        calculateContractPoints,
        // Custom functions
        getRanking,
        getCorpRankingPosition,
        // Custom functions / Application
        getUserRankingApplication,
        putUserRankingApplication,
        // Custom functions / Contracts
        deleteUserContract,
        getUserContracts,
        getUserContractById,
        postUserContract,
        putUserContract,
        postUserContractValidation,
        postUserContractValidationEmail,
        postUserContractReconsideration,
        getCompanyDetails,
        getStartupByDomain,
        // getCorporateRankingApplication,
        // putCorporateRankingApplication,
        // Corps - Ecosystem Relationship functions
        getCorpEcosystemRelationships,
        postCorpEcosystemRelationship,
        postCorpEcosystemRelationshipValidation,
        postCorpEcosystemRelationshipValidationEmail,
        putCorpEcosystemRelationship,
        deleteCorpEcosystemRelationship,
    };
}
export default useRankingCorporate;
